import { Text } from '@components/primitives/Text'
import AuthorBox from '.'

export const authorName = 'Michael Gill'
const authorAboutPath = 'michael-gill'
const authorCredential = 'B. Sc.'
export const authorDescription = ''
const authorImage = '92e8d147-4bd2-42ec-2760-8c2c2ff60500'

export function BaskAuthorBox({
  authorType,
  className,
  firstPublished,
  lastReviewed,
}: {
  authorType: string
  className?: string
  firstPublished: string
  lastReviewed: string
}) {
  return (
    <AuthorBox
      aboutPath={authorAboutPath}
      authorType={authorType}
      className={className}
      credential={authorCredential}
      description={
        <div className='grid grid-cols-1 gap-4'>
          <Text element='p' styleName='p-small' value={authorDescription} />
        </div>
      }
      firstPublished={firstPublished}
      imageSource={authorImage}
      lastReviewed={lastReviewed}
      name={authorName}
    />
  )
}
